/**
 * @todo Удалить файл
 * @description Данный функционал появился в задаче CD-246118, будет удалён в задаче CD-245073
 * Если переходим на базулу, то покрыть тестами
 * Если остаёмся на адфоксе, то удалить директорию полностью
 */

import { BuzzoolaBannerWithHide, BuzzoolaBannerWithHideProps } from '@cian/buzzoola-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackAdFoxBannerClick, trackAdFoxBannerView } from './tracking';
import { usePuidsSelector } from 'shared/hooks/usePuidsSelector';
import { selectSource } from 'shared/selectors';
import { getJsonQuery } from 'shared/selectors/getJsonQuery';

type BuzzoolaBannerContainerProps = Omit<BuzzoolaBannerWithHideProps, 'thirdPartyRequestParams'>;

export const BuzzoolaBannerContainer: React.FC<BuzzoolaBannerContainerProps> = props => {
  const puids = usePuidsSelector();
  const jsonQuery = useSelector(getJsonQuery);
  const source = useSelector(selectSource);

  const handleClick = React.useCallback(() => {
    trackAdFoxBannerClick(jsonQuery, source);
  }, [jsonQuery, source]);

  const handleShow = React.useCallback(() => {
    trackAdFoxBannerView(jsonQuery, source);
  }, [jsonQuery, source]);

  return (
    <BuzzoolaBannerWithHide {...props} thirdPartyRequestParams={puids} onClick={handleClick} onView1={handleShow} />
  );
};
